import React from 'react'
import { useState } from 'react'
import MyButton from '../../../../UI/form/MyButton'
import MyModal from '../../../../UI/modal/MyModal'
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import SeriesOneForm from './SeriesOneForm';

const SeriesOneFormAdd = ({ series }) => {

    const [open, setOpen] = useState(false)

  return (
    <>
        <MyButton
            onClick={e => setOpen(true)}
        >
            {
                series ? <EditIcon /> : <AddIcon />
            }
        </MyButton>

        <MyModal
            open={open}
            setOpen={setOpen}
            header={series ? 'Редагувати серію' : 'Додати серію'}
            disableClickOutside={true}
            content={
                <SeriesOneForm 
                    seriesBd={series}
                    setOpen={setOpen}
                />
            }
        />
    </>
  )
}

export default SeriesOneFormAdd